const notificationsTranslation = {
  'notifications.error.auth':
    'Ocorreu um erro ao realizar o login, verifique suas credenciais e tente novamente.',
  'notifications.success.auth': 'Login efetuado com sucesso!',
  'notifications.error.general':
    'Algo deu errado ao executar essa ação, por favor, tente novamente mais tarde.',
  'notifications.success.general': 'Ação executada com sucesso!',
  'notifications.error.create':
    'Algo deu errado ao cadastrar esse item, por favor, tente novamente mais tarde.',
  'notifications.success.create': 'Item cadastrado com sucesso!',
  'notifications.error.update':
    'Algo deu errado ao editar esse item, por favor, tente novamente mais tarde.',
  'notifications.success.update': 'Item editado com sucesso!',
  'notifications.error.remove':
    'Algo deu errado ao excluir esse item, por favor, tente novamente mais tarde.',
  'notifications.success.remove': 'Item excluído com sucesso!',
  'notifications.error.find':
    'Algo deu errado ao buscar esse item, por favor, tente novamente mais tarde.',
  'notifications.error.password': 'As senhas não coincidem.',
  'notifications.error.email': 'Os e-mails não coincidem.',
  'notifications.info.development':
    'Área em desenvolvimento, em breve mais informações',
};

export default notificationsTranslation;
